import { defineMessages } from '@cookbook/solid-intl'

// Split out of `connect-properties-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Manage your property connections on Lodgr. Link your listings and start syncing your properties quickly and easily.',
        id: 'ConnectPropertiesPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Connect Your Properties | Lodgr',
        id: 'ConnectPropertiesPage.titleMessage',
    }),
}
